import { render, staticRenderFns } from "./thirdChannelAdd.vue?vue&type=template&id=32bc9a3e&scoped=true"
import script from "./thirdChannelAdd.vue?vue&type=script&lang=js"
export * from "./thirdChannelAdd.vue?vue&type=script&lang=js"
import style0 from "./thirdChannelAdd.vue?vue&type=style&index=0&id=32bc9a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc9a3e",
  null
  
)

export default component.exports